import React, { ReactElement, FC } from "react";


import { ReactComponent as Yoda } from '../assets/Ambox_warning_pn.svg';


const ApiFailed: FC<any> = (): ReactElement => {



    return (
        <div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)',
            display: "flex"
            
        }}>
            <div style={{width: "40%", marginTop: "20px"} }>
                <Yoda />
            </div>
            <div className="text-center">
                {!window.location.hostname.includes('zonelog.net') && 
                <div>
                <div className="fa-2x ">The Aquaguard API has failed to respond.</div>
                <div className="fa-2x ">Please check your internet connection and try again.</div>
                <div className="fa-2x ">If the problem continues, please contact <a href="mailto:support@ash-eng.com">support@ash-eng.com</a></div>
                    </div>}
                {window.location.hostname.includes('zonelog.net') &&
                    <div>
                        <div className="fa-2x ">The ZONELOG API has failed to respond.</div>
                        <div className="fa-2x ">Please check your internet connection and try again.</div>
                        <div className="fa-2x ">If the problem continues, please contact <a href="mailto:support@zonelog.net">support@zonelog.net</a></div>
                    </div>}
            </div>
        </div>

    );

};

export default ApiFailed;